import React from 'react'
import { useTranslation } from 'react-i18next'

import FieldLabelWrapper from '../../../../features/components/Form/FieldLabelWrapper'
import MultiSelectBox from '../../../../features/components/Form/MultiSelectBox'

import {
  CONTENT_INSTREAM_POSITIONS,
  CONTENT_OUTSTREAM_POSITIONS,
  ON_SCREEN_POSITIONS
} from '../../UploadDV360AdCreative/UploadDV360AdCreativeForm/LineItemForm/fields'
import {
  formattedContentInstreamPositionOptions,
  formattedContentOutstreamPositionOptions,
  formattedOnScreenPositionOptions
} from '../../UploadDV360AdCreative/UploadDV360AdCreativeForm/LineItemForm/Steps/PositionStep/fields'

const PositionFields = ({ formik }) => {
  const { t } = useTranslation()

  const { values, setFieldValue } = formik

  return (
    <>
      <FieldLabelWrapper label={t('Position on screen')} labelFor={ON_SCREEN_POSITIONS}>
        <MultiSelectBox
          placeholder={t('Position on screen')}
          options={formattedOnScreenPositionOptions}
          name={ON_SCREEN_POSITIONS}
          value={values[ON_SCREEN_POSITIONS]}
          isLoading={false}
          setFieldValue={setFieldValue}
        />
      </FieldLabelWrapper>

      <FieldLabelWrapper label={t('Position in content (video in-stream)')} labelFor={CONTENT_INSTREAM_POSITIONS}>
        <MultiSelectBox
          placeholder={t('Position in content (video in-stream)')}
          options={formattedContentInstreamPositionOptions}
          name={CONTENT_INSTREAM_POSITIONS}
          value={values[CONTENT_INSTREAM_POSITIONS]}
          isLoading={false}
          setFieldValue={setFieldValue}
        />
      </FieldLabelWrapper>

      <FieldLabelWrapper label={t('Position in content (video out-stream)')} labelFor={ON_SCREEN_POSITIONS}>
        <MultiSelectBox
          placeholder={t('Position in content (video out-stream)')}
          options={formattedContentOutstreamPositionOptions}
          name={CONTENT_OUTSTREAM_POSITIONS}
          value={values[CONTENT_OUTSTREAM_POSITIONS]}
          isLoading={false}
          setFieldValue={setFieldValue}
        />
      </FieldLabelWrapper>
    </>
  )
}

export default PositionFields
